<template>
    <div class="max-w-screen-xl mx-auto mt-12 md:mt-18 lg:mt-20 xl:mt-24 md:mb-8 mb-6 px-4">

        <h2 class="text-2xl sm:text-3xl font-semibold mb-10" v-html="dataLocales.any_content.title">

        </h2>
        <div class="grid grid-cols-12 lg:gap-x-8 gap-y-8">
            <div class="lg:col-span-7 col-span-12">
                <div class="mb-6" v-for="post in dataLocales.data">
                    <h3 class="text-xl sm:text-2xl font-semibold mb-3"> {{ post.title }}</h3>
                    <div class="text-base lg:text-lg" v-html="post.description">

                    </div>
                </div>

                <p class="mt-4 text-lg" v-html="dataLocales.any_content.note">

                </p>
            </div>
            <div class="lg:col-span-5 lg:block hidden">
                <nuxt-img loading="lazy" src="/document.png" alt="document-to-qr-code" height="420px" format="webp" />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import MultiDataLocale from '~~/config/interface/MultiDataLocale';



const dataLocales = new MultiDataLocale([
    {
        locale: "en",
        title: " 📸 <span class='text-success'>Scan</span> for files and more content",
        note: " In addition to files, QR codes can also display rich content such as images, videos, text, and tables. Simply scan the code to view them.",
        data: [
            {
                title: "View files anytime, anywhere by scanning qr code.",
                description: "<p>The QR code is valid for a long time and always keeps the files. You can share files with friends and easily access important files by saving them for future viewing.</p>"
            },
            {
                title: "Quickly download files using your phone or computer.",
                description: "<p> You can download files to your phone, or scan the code to quickly transfer the file to your computer for downloading, printing, and other operations. </p> <p>Scanning the QR code will immediately redirect to the target website URL and record visitor data.</p>"
            }
        ]
    },
    {
        locale: "vi",
        title: "📸 <span class='text-success'>Quét</span> để tìm tập tin và nội dung khác",
        note: "Ngoài tập tin, mã QR còn có thể hiển thị nội dung phong phú như hình ảnh, video, văn bản và bảng. Chỉ cần quét mã để xem chúng.",
        data: [
            {
                title: "Xem tập tin bất cứ lúc nào, ở bất cứ đâu bằng cách quét mã QR.",
                description: "<p>Mã QR có hiệu lực trong thời gian dài và luôn giữ các tập tin. Bạn có thể chia sẻ tập tin với bạn bè và dễ dàng truy cập vào các tập tin quan trọng bằng cách lưu chúng để xem lại trong tương lai.</p>"
            },
            {
                title: "Nhanh chóng tải xuống tập tin bằng điện thoại hoặc máy tính của bạn.",
                description: "<p>Bạn có thể tải tập tin về điện thoại của mình hoặc quét mã để nhanh chóng chuyển tập tin sang máy tính của bạn để tải xuống, in ấn và thực hiện các hoạt động khác.</p> <p>Quét mã QR sẽ ngay lập tức chuyển hướng đến địa chỉ URL của trang web đích và ghi lại dữ liệu của khách truy cập.</p>"
            }
        ]
    },
    {
        locale: "de",
        title: "📸 <span class='text-success'>Scannen</span> Sie nach Dateien und mehr Inhalten",
        note: "Neben Dateien können QR-Codes auch reichhaltigen Inhalt wie Bilder, Videos, Texte und Tabellen anzeigen. Scannen Sie einfach den Code, um sie anzuzeigen.",
        data: [
            {
                title: "Dateien jederzeit und überall anzeigen, indem Sie den QR-Code scannen.",
                description: "<p>Der QR-Code ist lang gültig und behält immer die Dateien. Sie können Dateien mit Freunden teilen und wichtige Dateien einfach zugreifen, indem Sie sie zum späteren Anzeigen speichern.</p>"
            },
            {
                title: "Dateien schnell mit Ihrem Telefon oder Computer herunterladen.",
                description: "<p>Sie können Dateien auf Ihr Telefon herunterladen oder den Code scannen, um die Datei schnell auf Ihren Computer zu übertragen, um sie herunterzuladen, zu drucken und andere Vorgänge auszuführen.</p> <p>Das Scannen des QR-Codes leitet Sie sofort zur Ziel-Website-URL weiter und zeichnet Besucherdaten auf.</p>"
            }
        ]
    },
    {
        locale: "fr",
        title: "📸 <span class='text-success'>Numérisez</span> pour trouver des fichiers et d'autres contenus",
        note: "En plus des fichiers, les codes QR peuvent afficher du contenu riche tel que des images, des vidéos, du texte et des tableaux. Il suffit de numériser le code pour les afficher.",
        data: [
            {
                title: "Afficher des fichiers à tout moment et n'importe où en numérisant le code QR.",
                description: "<p>Le code QR est valide pendant longtemps et conserve toujours les fichiers. Vous pouvez partager des fichiers avec des amis et accéder facilement aux fichiers importants en les enregistrant pour une visualisation ultérieure.</p>"
            },
            {
                title: "Téléchargez rapidement des fichiers à l'aide de votre téléphone ou de votre ordinateur.",
                description: "<p>Vous pouvez télécharger des fichiers sur votre téléphone ou numériser le code pour transférer rapidement le fichier sur votre ordinateur pour le téléchargement, l'impression et d'autres opérations. </p> <p>La numérisation du code QR redirigera immédiatement vers l'URL du site Web cible et enregistrera les données des visiteurs.</p>"
            }
        ]
    },
    {
        locale: "es",
        title: "📸 <span class='text-success'>Escanea</span> para encontrar archivos y más contenido",
        note: "Además de los archivos, los códigos QR también pueden mostrar contenido rico como imágenes, videos, texto y tablas. Simplemente escanea el código para verlos.",
        data: [
            {
                title: "Ver archivos en cualquier momento y lugar escaneando el código QR.",
                description: "<p>El código QR es válido durante mucho tiempo y siempre mantiene los archivos. Puedes compartir archivos con amigos y acceder fácilmente a archivos importantes guardándolos para verlos más tarde.</p>"
            },
            {
                title: "Descarga archivos rápidamente usando tu teléfono o computadora.",
                description: "<p>Puedes descargar archivos en tu teléfono, o escanear el código para transferir rápidamente el archivo a tu computadora para descargarlo, imprimirlo y realizar otras operaciones. </p> <p>Escaneando el código QR se redireccionará inmediatamente a la URL del sitio web objetivo y se registrarán los datos del visitante.</p>"
            }
        ]
    },
    {
        locale: "it",
        title: "📸 <span class='text-success'>Scansiona</span> per trovare file e altro contenuto",
        note: "Oltre ai file, i codici QR possono mostrare contenuti ricchi come immagini, video, testo e tabelle. Basta scansionare il codice per visualizzarli.",
        data: [
            {
                title: "Visualizza i file in qualsiasi momento e ovunque scansionando il codice QR.",
                description: "<p>Il codice QR è valido per molto tempo e mantiene sempre i file. Puoi condividere i file con gli amici e accedere facilmente ai file importanti salvandoli per la visualizzazione futura.</p>"
            },
            {
                title: "Scarica rapidamente i file utilizzando il tuo telefono o computer.",
                description: "<p>Puoi scaricare i file sul tuo telefono o scansionare il codice per trasferire rapidamente il file al tuo computer per il download, la stampa e altre operazioni. </p> <p>La scansione del codice QR reindirizzerà immediatamente all'URL del sito web di destinazione e registrerà i dati dei visitatori.</p>"
            }
        ]
    },
    {
        locale: "nl",
        title: "📸 <span class='text-success'>Scan</span> voor bestanden en meer inhoud",
        note: "Naast bestanden kunnen QR-codes ook rijke inhoud weergeven zoals afbeeldingen, video's, tekst en tabellen. Scan eenvoudig de code om ze te bekijken.",
        data: [
            {
                title: "Bekijk bestanden altijd en overal door de QR-code te scannen.",
                description: "<p>De QR-code is lang geldig en bewaart altijd de bestanden. U kunt bestanden delen met vrienden en belangrijke bestanden gemakkelijk openen door ze op te slaan voor toekomstige weergave.</p>"
            },
            {
                title: "Download bestanden snel met uw telefoon of computer.",
                description: "<p>U kunt bestanden downloaden naar uw telefoon, of de code scannen om het bestand snel over te zetten naar uw computer om te downloaden, te printen en andere bewerkingen uit te voeren.</p> <p>Het scannen van de QR-code leidt direct naar de doelwebsite-URL en registreert bezoekersgegevens.</p>"
            }
        ]
    },
    {
        locale: "pt",
        title: "📸 <span class='text-success'>Digitalize</span> para encontrar arquivos e mais conteúdo",
        note: "Além de arquivos, códigos QR também podem exibir conteúdo rico, como imagens, vídeos, texto e tabelas. Basta digitalizar o código para visualizá-los.",
        data: [
            {
                title: "Visualize arquivos a qualquer momento e em qualquer lugar digitalizando o código QR.",
                description: "<p>O código QR é válido por um longo período de tempo e sempre mantém os arquivos. Você pode compartilhar arquivos com amigos e acessar facilmente arquivos importantes salvando-os para visualização futura.</p>"
            },
            {
                title: "Baixe arquivos rapidamente usando seu telefone ou computador.",
                description: "<p>Você pode baixar arquivos em seu telefone ou digitalizar o código para transferir rapidamente o arquivo para o seu computador para download, impressão e outras operações. </p> <p>A digitalização do código QR redireciona imediatamente para a URL do site de destino e registra dados do visitante.</p>"
            }
        ]
    },
    {
        locale: "ja",
        title: "📸 ファイルやその他のコンテンツを検索するための<span class='text-success'>スキャン</span>",
        note: "ファイル以外にも、QRコードには画像、動画、テキスト、表などの豊富なコンテンツを表示することができます。コードをスキャンして簡単に閲覧できます。",
        data: [
            {
                title: "QRコードをスキャンしていつでもどこでもファイルを表示できます。",
                description: "<p>QRコードは長期間有効であり、常にファイルを保持しています。友達とファイルを共有したり、重要なファイルを保存して将来の閲覧のために簡単にアクセスすることができます。</p>"
            },
            {
                title: "電話やコンピュータを使用して迅速にファイルをダウンロードできます。",
                description: "<p>電話でファイルをダウンロードすることもできますし、コードをスキャンしてすばやくコンピュータに転送してダウンロード、印刷、その他の操作を行うこともできます。</p><p>QRコードをスキャンするとすぐに対象のウェブサイトのURLにリダイレクトされ、訪問者データが記録されます。</p>"
            }
        ]
    },
    {
        locale: "zh",
        title: "📸 <span class='text-success'>扫描</span> 获取文件和更多内容",
        note: "除了文件，QR码还可以显示图像、视频、文本和表格等丰富的内容。只需扫描代码即可查看。",
        data: [
            {
                title: "通过扫描QR码随时随地查看文件。",
                description: "<p>QR码长时间有效并始终保留文件。您可以与朋友共享文件，通过将其保存以备将来查看来轻松访问重要文件。</p>"
            },
            {
                title: "使用手机或计算机快速下载文件。",
                description: "<p>您可以将文件下载到手机上，或者扫描代码将文件快速传输到计算机以进行下载、打印和其他操作。</p><p>扫描QR码将立即重定向到目标网站URL并记录访客数据。</p>"
            }
        ]
    }
])

</script>